var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"500px","margin-right":"auto","margin-left":"auto"}},[_c('Plants'),_c('Sharings')],1)}
var staticRenderFns = []

export { render, staticRenderFns }